// fork overlay: fork-owned helper (WhatsApp Web pairing guard) — no OSS counterpart.
// Issue #113: whether a QR scan paired the number the user registered is decided
// server-side — DevicesController#status compares the paired JID with it,
// accepting the BR ninth-digit sibling (Fork::WhatsappWebPhone) — and reported as
// `phone_match`. The setup wizard and the settings page both read it here, so
// neither re-implements the rule. A status without `phone_match` (a server that
// predates it, mid-deploy or after a rollback) falls back to the exact comparison
// those servers relied on, so a scan is never accepted unchecked.
export const extractPhoneFromJid = jid => {
  if (!jid) return '';
  return jid.split('@')[0];
};

const normalizePhone = phone => (phone ? phone.replace(/\D/g, '') : '');

export const isPhoneMismatch = (status, expectedPhone) => {
  if (status?.state !== 'logged_in') return false;
  if (typeof status.phone_match === 'boolean') return !status.phone_match;

  const expected = normalizePhone(expectedPhone);
  const connected = normalizePhone(extractPhoneFromJid(status.jid));
  return Boolean(expected && connected && expected !== connected);
};
